import React from "react";
import HtmlContent, { PhotoLink } from "./HtmlContent";
import { mediaUrl } from "../lib/siteApi";

const CORE = new Set(["hero", "about", "contact", "footer", "cta", "services", "projects", "values", "servicePage"]);

export default function CmsSections({ content = [] }) {
  const items = (content || []).filter((item) => !CORE.has(item.section));
  if (!items.length) return null;

  return (
    <>
      {items.map((block) => {
        const image = mediaUrl(block.imageUrl);
        const to = `/#${block.section || "home"}`;
        return (
          <section key={block.id} className="relative py-16 bg-white dark:bg-slate-900" id={block.section || block.key}>
            <div className="container max-w-4xl">
              {image ? (
                <PhotoLink to={to} src={image} alt={block.title || ""} className="w-full rounded-3xl shadow-xl object-cover max-h-[380px]" wrapClassName="mb-6 rounded-3xl" />
              ) : null}
              {block.title ? <h2 className="renerg-section text-slate-900 dark:text-white mb-4">{block.title}</h2> : null}
              <HtmlContent html={block.body} className="renerg-body text-slate-600 dark:text-slate-300" imageTo={to} />
            </div>
          </section>
        );
      })}
    </>
  );
}
